import React from "react";
import posthog from "posthog-js";

import {nodeEnv, postHogHost, postHogKey} from "./src/constants/config";

import "./src/styles/global.scss";

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
    if (typeof window !== "undefined") {
        posthog.init(postHogKey, {
            api_host: postHogHost,
            debug: nodeEnv === "development",
        });
    }

    return element;
};
